var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[(_vm.timerCount > 0)?_c('div',[_vm._v("Отправить повторно через "+_vm._s(_vm.timerCount)+" сек.")]):_c('div',{staticClass:"resend_code",on:{"click":_vm.emitResendAction}},[_vm._v("Получить код ещё раз")])])}
var staticRenderFns = []

export { render, staticRenderFns }